module.exports = "/assets/data/bf57c697c44904ee57c591eac3bf204c-EH52.data.json";